import React from "react";

export const SvgSprite = () => {

  return (
    <svg className="visually-hidden">
      <defs>
        <symbol id="icon-external" viewBox="0 0 24 24">
          <path fillRule="evenodd" clipRule="evenodd"
                d="M5 5V19H19V12H21V21H3V3H12V5H5ZM14 5V3H21V10H19V6.41L9.17 16.24L7.76 14.83L17.59 5H14Z"
                fill="currentColor"/>
        </symbol>
        <symbol id="icon-download" viewBox="0 0 16 16">
          <path fillRule="evenodd" clipRule="evenodd"
                d="M9.9987 6.3335H12.6654L7.9987 11.0002L3.33203 6.3335H5.9987V2.3335H9.9987V6.3335ZM3.33203 13.6668V12.3335H12.6654V13.6668H3.33203Z"
                fill="currentColor"/>
        </symbol>
        <symbol id="icon-arrow-down-r" viewBox="0 0 14 14">
          <path d="M12.5 1.24V12.5H1M12.5 12.5 1 1" stroke="currentColor" strokeWidth="2"/>
        </symbol>
        <symbol id="icon-arrow-up" viewBox="0 0 16 16" fill="none">
          <path d="M7.33 14.67V3.88L4.27 6.93 3.33 6 8 1.33 12.67 6l-.94.95-3.06-3.07v10.79H7.33Z" fill="currentColor"/>
        </symbol>
        <symbol id="icon-close" viewBox="0 0 16 16" fill="none">
          <path d="M12.86 13.8 2.2 3.14l.94-.94L13.8 12.86l-.94.94Z"
                fill="currentColor"/>
          <path d="M2.2 12.86 12.86 2.2l.94.94L3.14 13.8l-.94-.94Z"
                fill="currentColor"/>
        </symbol>
        <symbol id="icon-clock" viewBox="0 0 24 24" fill="none">
          <path
            d="m15.3 16.7 1.4-1.4-3.7-3.7V7h-2v5.4l4.3 4.3ZM12 22a10.1 10.1 0 0 1-9.21-6.1A9.74 9.74 0 0 1 2 12a10.1 10.1 0 0 1 6.1-9.21A9.74 9.74 0 0 1 12 2a10.1 10.1 0 0 1 9.21 6.1c.53 1.22.79 2.52.79 3.9s-.26 2.68-.79 3.9a10.1 10.1 0 0 1-5.31 5.31A9.74 9.74 0 0 1 12 22Zm0-2c2.22 0 4.1-.78 5.66-2.34A7.71 7.71 0 0 0 20 12c0-2.22-.78-4.1-2.34-5.66A7.71 7.71 0 0 0 12 4c-2.22 0-4.1.78-5.66 2.34A7.71 7.71 0 0 0 4 12c0 2.22.78 4.1 2.34 5.66A7.71 7.71 0 0 0 12 20Z"
            fill="currentColor"/>
        </symbol>
        <symbol id="icon-user" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 11.58a4.44 4.44 0 0 1-3.3-1.4 4.67 4.67 0 0 1-1.37-3.4c0-1.3.46-2.44 1.37-3.37A4.44 4.44 0 0 1 12 2c1.28 0 2.38.47 3.3 1.4a4.67 4.67 0 0 1 1.37 3.39c0 1.32-.46 2.44-1.37 3.38a4.44 4.44 0 0 1-3.3 1.4ZM2 22v-3.04a3.58 3.58 0 0 1 1.95-3.18 19.03 19.03 0 0 1 4-1.5 16.84 16.84 0 0 1 8.1 0c1.35.34 2.68.84 4 1.5A3.58 3.58 0 0 1 22 18.96V22H2Zm2-2.05h16v-1c0-.27-.08-.53-.23-.76a1.8 1.8 0 0 0-.64-.58 16.87 16.87 0 0 0-3.52-1.32 14.82 14.82 0 0 0-7.22 0c-1.2.3-2.37.74-3.52 1.32a1.8 1.8 0 0 0-.64.58c-.15.23-.23.5-.23.77v.99Zm8-10.42c.73 0 1.36-.27 1.88-.8.53-.54.79-1.19.79-1.94s-.26-1.4-.79-1.93a2.54 2.54 0 0 0-1.88-.8c-.73 0-1.36.26-1.88.8a2.67 2.67 0 0 0-.79 1.93c0 .75.26 1.4.79 1.93.52.54 1.15.8 1.88.8Z"
            fill="currentColor"/>
        </symbol>
        <symbol id="icon-arrow-toggle" viewBox="0 0 24 24" fill="none">
          <path d="M16.59 8.3 12 12.86 7.41 8.3 6 9.7l6 6 6-6-1.41-1.4Z" fill="currentColor"/>
        </symbol>
        <symbol id="icon-search" viewBox="0 0 20 20" fill="none">
          <path
            d="m18.63 17.28-4.15-4.15a.4.4 0 0 0-.29-.12h-.45a7.1 7.1 0 1 0-.73.73v.45c0 .11.04.21.12.3l4.15 4.14c.16.16.42.16.58 0l.77-.77a.41.41 0 0 0 0-.58ZM8.36 13.83a5.47 5.47 0 1 1 0-10.94 5.47 5.47 0 0 1 0 10.94Z"
            fill="currentColor"/>
        </symbol>
        <symbol id="icon-rootstock" viewBox="0 0 20 20" fill="none">
          <path
            d="M9.6 6.47c1.32 0 2.38-1.25 2.38-2.78 0-1.53-1.06-2.78-2.38-2.78C8.3.91 7.22 2.16 7.22 3.7c0 1.53 1.07 2.78 2.38 2.78Z"
            fill="currentColor"/>
          <path
            d="M17.06 11.1a2.54 2.54 0 0 0-3.8 2.25c.02 1.12-.98 1.7-1.94 1.12a2.53 2.53 0 0 0-.12-.06c-.96-.54-.96-1.69 0-2.23a2.53 2.53 0 0 0 1.34-2.22V9.9c-.03-1.12.98-1.7 1.94-1.12a2.54 2.54 0 0 0 3.51-3.43 2.54 2.54 0 0 0-4.73 1.33c.02 1.11-.98 1.7-1.94 1.12a2.53 2.53 0 0 0-2.64 0c-.96.57-1.96-.01-1.93-1.12A2.54 2.54 0 0 0 2 5.36a2.53 2.53 0 0 0 3.52 3.42c.95-.57 1.96 0 1.93 1.12v.06c0 .96.54 1.8 1.33 2.22.97.54.97 1.7 0 2.23l-.11.06c-.96.58-1.96 0-1.93-1.11A2.54 2.54 0 1 0 2 14.57a2.54 2.54 0 0 0 3.47.92l.04-.03c.96-.58 1.96 0 1.94 1.12v.06a2.53 2.53 0 0 0 5.07 0v-.06c-.02-1.12.99-1.7 1.95-1.12l.05.03a2.53 2.53 0 1 0 2.54-4.39Z"
            fill="currentColor"/>
        </symbol>
        <symbol id="icon-doc" viewBox="0 0 24 24" fill="none">
          <path fill="currentColor"
            d="m19.27 6.97-5.24-5.25a.68.68 0 0 0-.53-.22H6c-.83 0-1.5.67-1.5 1.5v18c0 .82.67 1.5 1.5 1.5h12c.82 0 1.5-.68 1.5-1.5V7.5a.68.68 0 0 0-.23-.53ZM13.5 3.3l4.2 4.2h-4.2V3.3ZM18 21H6V3h6v4.5c0 .82.68 1.5 1.5 1.5H18v12Z"/>
          <path fill="currentColor" d="M16.5 16.5h-9V18h9v-1.5ZM16.5 12h-9v1.5h9V12Z"/>
        </symbol>
        <symbol id="icon-calendar" viewBox="0 0 24 24" fill="none">
          <path d="M3 22V4H6V2H8V4H16V2H18V4H21V22H3ZM5 20H19V10H5V20ZM5 8H19V6H5V8Z" fill="currentColor"/>
        </symbol>
        <symbol id="icon-arrow-right" viewBox="0 0 24 24" fill="none">
          <path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" fill="currentColor"/>
        </symbol>
      </defs>
    </svg>
  )
}

